const Instructions = require("./components/Instructions");
const Authenticate = require("../utils").authenticate;

// Sync route definition
module.exports = {
    path: "/instructions",
    component: Authenticate(Instructions),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/instructions/index.js